"use client";
import { IeltsHomeTabs } from "@/lib/utils";
import { ieltsThemeAtom } from '@/store/home';
import { useAtom } from 'jotai';
import useTranslation from "next-translate/useTranslation";
import Link from 'next/link';
import { useAuth } from "@/providers/auth";
import ROUTES from "@/lib/routes";
import { useCallback, useState, useEffect } from 'react';
import { createEnumParam } from 'use-query-params';
import dynamic from 'next/dynamic';
import SidebarMenu, { NotificationsMenuItem } from "./SidebarMenu";
import UserProfilePopup from "./UserProfilePopup";
import { twMerge } from "tailwind-merge";
import LogoDefault from '@/assets/images/common/logo.png';
import Image from 'next/image';

const BtnExpand = dynamic(() => import('@/assets/images/common/btnExpand.svg'), { ssr: false });
const DynamicChooseThemeModal = dynamic(() => import('@/components/common/ChooseTheme/ChooseThemeModal'), { ssr: false });

export const IeltsHomeTabsParams = createEnumParam(Object.values(IeltsHomeTabs));

export default function HeaderMobileIeltsV2() {
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);
  const [showThemeModal, setShowThemeModal] = useState<boolean>(false);
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  const { t: ieltsTranslation } = useTranslation('ielts');
  const [ieltsTheme, setIeltsTheme] = useAtom(ieltsThemeAtom);

  const handleChangeInterface = useCallback(() => {
    setShowThemeModal(true);
  }, []);

  const { currentLearnerProfile } = useAuth();

  const toggleSidebar = useCallback(() => {
    setIsOpenMenu(!isOpenMenu);
  }, [isOpenMenu]);

  if (!isMounted) {
    return <div className="flex fixed top-0 left-0 z-[99] bg-ielts-surface w-full border-b-[1px] border-ielts-line h-[45px]"></div>;
  }

  return (
    <>
      <div className={twMerge('flex fixed top-0 left-0 z-[99] bg-ielts-surface w-full border-b-[1px] border-ielts-line h-[45px]')}>
        <div className="flex items-center justify-between w-full px-2">
          <div className="flex items-center gap-0 justify-between">
            <div className="flex items-center">
              <div
                className="w-[28px] h-[28px] flex items-center justify-center cursor-pointer text-ielts-fg-secondary hover:text-ielts-accent hover:rounded-full transition-all duration-300"
                onClick={toggleSidebar}
              >
                <BtnExpand />
              </div>
              <h1
                className={twMerge(
                  'text-lg font-bold overflow-hidden transition-all duration-500 ease-in-out whitespace-nowrap',
                  'text-ielts-fg',
                  isOpenMenu ? 'w-0 opacity-0 ml-0' : 'w-auto opacity-100 ml-2'
                )}
              >
                MOCK TEST
              </h1>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <NotificationsMenuItem />
            <UserProfilePopup isCollapsed={false} onChangeInterface={handleChangeInterface} />
          </div>
        </div>
      </div>
      <>
        <div
          className={twMerge(
            'fixed left-0 top-0 z-[9999] bg-ielts-surface shadow-[0px_10px_14px_0px_rgba(0,0,0,0.25)] flex flex-col h-screen transform w-[310px] px-4 pt-2 shadow-sm transition-all duration-300 ease-in-out',
            isOpenMenu ? 'translate-x-0' : '-translate-x-full'
          )}
        >
          {/* Header with logo */}
          <div className="flex items-center gap-3 mb-8 mt-2 justify-between">
            <div className="flex items-center gap-0 justify-between">
              <Link className="flex items-center" href={ROUTES.EDIT_PROFILE}>
                <div className={twMerge('w-[59px] h-[55px]')}>
                  <Image src={LogoDefault.src} alt="Logo" width={59} height={55} />
                </div>
                <h1
                  className={twMerge(
                    'text-[18px] font-bold w-auto opacity-100 ml-2 overflow-hidden transition-all duration-500 ease-in-out whitespace-nowrap',
                    'text-ielts-fg'
                  )}
                >
                  {ieltsTranslation('homepage.textLogo')}
                </h1>
              </Link>
            </div>

            <div
              className="w-[28px] h-[28px] flex items-center justify-center cursor-pointer text-ielts-fg-secondary hover:text-ielts-accent hover:rounded-full transition-all duration-300"
              onClick={toggleSidebar}
            >
              <BtnExpand />
            </div>
          </div>
          {/* Main navigation */}
          <SidebarMenu activeKey="mock-test" toggleSidebar={toggleSidebar} />
        </div>
        <div
          className={twMerge(
            'w-full h-full bg-[#000] bg-opacity-90 fixed left-0 top-0 z-[9998] transition-opacity duration-300 ease-in-out',
            isOpenMenu ? 'opacity-50' : 'opacity-0 pointer-events-none'
          )}
          onClick={() => {
            setIsOpenMenu(!isOpenMenu);
          }}
        />
      </>

      {/* Theme Modal */}
      <DynamicChooseThemeModal
        open={showThemeModal}
        onClose={() => setShowThemeModal(false)}
        onSelectTheme={(theme) => {
          setIeltsTheme(theme);
          setShowThemeModal(false);
        }}
        activeTheme={ieltsTheme}
      />
    </>
  );
}
